import React from 'react';
import { generatePath, Navigate, useParams } from 'react-router';

const RouteWildCardSolver = ({ redirection }) => {
  const { workspaceId, deviceId } = useParams();
  return (
    <Navigate
      to={generatePath(redirection, { workspaceId, deviceId })}
      replace
    />
  );
};

export default RouteWildCardSolver;
